import { render, staticRenderFns } from "./PlanBrandNew.vue?vue&type=template&id=557f483e&lang=pug&"
import script from "./PlanBrandNew.vue?vue&type=script&lang=ts&"
export * from "./PlanBrandNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports